import type { Address } from 'viem'

import { ChainId } from '@morpho-org/blue-sdk'

export const READ_ONLY_VAULTS: Record<ChainId, Record<Address, string>> = {
  [ChainId.EthMainnet]: {
    '0x4Ff4186188f8406917293A9e01A1ca16d3cf9E59':
      'Deposits in this vault are only available via the SwissBorg app.', // SwissBorg
    '0x059Fc6723b9bF77DbF4283C8d7C90eA8Af44EF10':
      'Deposits in this vault are only available via the SwissBorg app.' // SwissBorg
  },
  [ChainId.BaseMainnet]: {},
  [ChainId.ArbitrumMainnet]: {},
  [ChainId.OptimismMainnet]: {},
  [ChainId.PolygonMainnet]: {},
  [ChainId.WorldChainMainnet]: {},
  [ChainId.FraxtalMainnet]: {},
  [ChainId.ScrollMainnet]: {},
  [ChainId.InkMainnet]: {},
  [ChainId.Unichain]: {},
  [ChainId.SonicMainnet]: {},
  [ChainId.HemiMainnet]: {},
  [ChainId.ModeMainnet]: {},
  [ChainId.CornMainnet]: {},
  [ChainId.PlumeMainnet]: {},
  [ChainId.CampMainnet]: {},
  [ChainId.KatanaMainnet]: {},
  [ChainId.EtherlinkMainnet]: {},
  [ChainId.TacMainnet]: {},
  [ChainId.LiskMainnet]: {},
  [ChainId.HyperliquidMainnet]: {},
  [ChainId.MonadMainnet]: {},
  [ChainId.SeiMainnet]: {},
  [ChainId.ZeroGMainnet]: {},
  [ChainId.LineaMainnet]: {},
  [ChainId.StableMainnet]: {},
  [ChainId.CronosMainnet]: {},
  [ChainId.CeloMainnet]: {},
  [ChainId.AbstractMainnet]: {},
  [ChainId.BitlayerMainnet]: {},
  [ChainId.SoneiumMainnet]: {},
  [ChainId.BscMainnet]: {},
  [ChainId.TempoMainnet]: {},
  [ChainId.EdenMainnet]: {},
  [ChainId.PharosMainnet]: {},
  [ChainId.GensynMainnet]: {},
  [ChainId.FlareMainnet]: {},
  [ChainId.XdcMainnet]: {},
  [ChainId.KaiaMainnet]: {},
  [ChainId.RobinhoodMainnet]: {},
  [ChainId.ArcMainnet]: {},
  [ChainId.MorphMainnet]: {},
  [ChainId.MegaEthMainnet]: {}
}
